module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brutto text-dark",
    class: {
      'brutto--kindergarten': _vm.isKindergarten
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.setIsNormModal
    }
  }, [_vm._v("Normberegning")]), _vm._v(" "), (_vm.isActive) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-container",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-container__header"
  }, [_c('h2', [_vm._v("Normberegning")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__body"
  }, [_c('div', {
    staticClass: "brutto-container__body__left"
  }, [_c('div', {
    staticClass: "d-tabs"
  }, [_c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.getIsActiveTab(0)
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab(0)
      }
    }
  }, [_vm._v("\n              Bruttotid\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__tab",
    class: {
      'd-tabs__tab--active': _vm.getIsActiveTab(1)
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab(1)
      }
    }
  }, [_vm._v("\n              Nettotid\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-tabs__content"
  }, [_c('AssignHoursNormList', {
    attrs: {
      "standardNettoHours": _vm.originalNettoTime,
      "isNetto": _vm.activeTab === 1,
      "isKindergarten": _vm.isKindergarten,
      "schoolYear": _vm.activeSchoolYear,
      "theEditUserNorm": _vm.theEditUserNorm
    },
    on: {
      "onEditBrutto": function($event) {
        return _vm.setActiveTab(0)
      },
      "onEditNetto": function($event) {
        return _vm.setActiveTab(1)
      },
      "updated": _vm.setItemsToSave,
      "changedSum": _vm.setNettoTime,
      "onEditedStandardWorkingHours": function($event) {
        return _vm.setIsShowNewNettoModal($event)
      },
      "changedEmploymentRate": _vm.onChangedEmploymentRate
    }
  })], 1), _vm._v(" "), (!_vm.isKindergarten && !_vm.isPoolsDeactivated) ? _c('div', {
    staticClass: "more-norms"
  }, [_c('div', {
    staticClass: "rest-calculation"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Rest / Ikke fordelt på puljer")]), _vm._v("\n              " + _vm._s(_vm.restCalculation) + "\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "brutto__items"
  }, _vm._l((_vm.items), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "brutto__items__item__container"
    }, [_c('div', {
      staticClass: "label-with-toggle",
      on: {
        "click": function($event) {
          return _vm.toggleItem(idx)
        }
      }
    }, [_c('label', {
      staticClass: "d-label"
    }, [_vm._v("Indsæt " + _vm._s(item.name))]), _vm._v(" "), _c('app-toggle', {
      attrs: {
        "allowChanges": false,
        "propOn": _vm.isItemToggled(idx)
      }
    })], 1), _vm._v(" "), (_vm.isItemToggled(idx)) ? _c('div', {
      staticClass: "brutto__items__item"
    }, [_c('span', {
      staticClass: "norm-title"
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                    "), (_vm.prepFactor && item.id === 'assigned_preparation_hours') ? _c('span', {
      staticClass: "norm-title__sub"
    }, [_vm._v("\n                      " + _vm._s(_vm.prepFactor) + " Forberedelesfaktor * " + _vm._s(_vm.hoursForTeaching) + " UV\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return _vm.isShowPrepFactorTooltip(item); }
        }),
        expression: "{\n                    arrow: true,\n                    animateFill: false,\n                    animation : 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window',\n                    onShow: () => isShowPrepFactorTooltip(item)\n                  }"
      }],
      staticClass: "d-input-group__input",
      attrs: {
        "content": "Forberedelse opdateres automatisk ift. hvad der er tildelt i \"Undervisning\""
      }
    }, [(_vm.isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && _vm.prepFactor)) ? _c('div', {
      staticClass: "employment-rate-calculator"
    }, [_vm._v("\n                      (" + _vm._s(_vm.formatEmploymentRateText(item)) + ")\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.unit ? item.unit : 'timer'))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.hours),
        expression: "item.hours"
      }],
      attrs: {
        "disabled": _vm.prepFactor && item.id === 'assigned_preparation_hours',
        "type": "number"
      },
      domProps: {
        "value": (item.hours)
      },
      on: {
        "change": function($event) {
          return _vm.onUpdatingHours(item, $event.target.value)
        },
        "focus": function($event) {
          return $event.target.select()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "hours", $event.target.value)
        }
      }
    })])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brutto__items__item__container brutto__items__item__container__notefield",
    class: {
      'brutto__items__item__container__notefield--alone': _vm.isPoolsDeactivated
    }
  }, [_c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": _vm.setIsShowAgreement
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Indsæt en note til de valgte personer")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isShowAgreement
    }
  })], 1), _vm._v(" "), (_vm.isShowAgreement) ? _c('AppEIPWYZIWYG', {
    attrs: {
      "isKeepOpen": true,
      "is-open": true,
      "isInTestOfSaveButton": false
    },
    on: {
      "changed": _vm.updateAgreements
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAgreement) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_c('svg', {
    staticClass: "icon-archive tw-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"
    }
  })]), _vm._v("\n              Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "brutto__users"
  }, [_c('div', {
    staticClass: "brutto__users__header"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "users": _vm.usersSortedOnNameWithTags,
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters
    },
    on: {
      "clear": function($event) {
        _vm.appliedFilters = []
      },
      "select": _vm.toggleFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "norm-select-users__header"
  }, [_c('div', {
    staticClass: "text-link",
    on: {
      "click": _vm.toggleAll
    }
  }, [_vm._v("\n              " + _vm._s(_vm.selectedUsers.length < 1 ? 'Vælg alle' : 'Fravælg alle') + "\n            ")]), _vm._v(" "), _c('span', [_vm._v(" Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.usersSortedOnName.length))])]), _vm._v(" "), _c('ul', {
    staticClass: "brutto__users__list"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "brutto__users__user",
      class: {
        'is-selected': _vm.getIsUserSelected(user)
      },
      on: {
        "click": function($event) {
          return _vm.toggleUser(user)
        }
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n              "), _c('div', {
      staticClass: "icon__bg-circle d-edit-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editUserNorm(user)
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-container__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        onShow: function () { return _vm.selectedUsers.length < 1; }
      }),
      expression: "{\n                  arrow: true,\n                  onShow: () => selectedUsers.length < 1\n                }"
    }],
    staticClass: "bttn bttn-primary",
    class: [{
      'bttn-primary--disabled': _vm.selectedUsers.length < 1
    }, {
      'bttn--loading': _vm.isSaving
    }],
    attrs: {
      "content": "Der skal vælges minimum en bruger"
    },
    on: {
      "click": function($event) {
        _vm.isWarningActive = true
      }
    }
  }, [_vm._v("Gem\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isWarningActive) ? _c('DModal', {
    staticStyle: {
      "z-index": "999999999"
    },
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v("Gem og erstat?")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Du er ved at tildele arbejdstid på " + _vm._s(_vm.nettoTime) + " til de valgte brugere. Hvis der i forvejen er tildelt en\n          arbejdstid vil dette blive erstattet.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isWarningActive = false
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary bttn-primary--small",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Gem\n          og erstat\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.theNewNettoValue) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowNewNettoModal(null)
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v("Vil du gemme " + _vm._s(_vm.theNewNettoValue) + " som den nye standard netto tid på skolen, så du ikke skal\n      taste det næste gang?")]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setIsShowNewNettoModal(null)
      }
    }
  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveNewNettoTime
    }
  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.theNewStandardHoursForPool) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.setTheNewStandardHoursForPool(null)
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v("\n      Vil du gemme "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.hours) + " timer")]), _vm._v(" som den nye standard for\n      "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.theNewStandardHoursForPool.name) + "-puljen")]), _vm._v(", så du ikke behøver at indtaste det næste\n      gang?\n    ")]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.setTheNewStandardHoursForPool(null)
      }
    }
  }, [_vm._v("\n        Ikke gem\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.saveNewStandardHours
    }
  }, [_vm._v("\n        Gem som ny standard\n      ")])])], 2) : _vm._e(), _vm._v(" "), (_vm.isModalAutoCalculateOpen) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        _vm.isModalAutoCalculateOpen = false
      }
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h3', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("Skal puljer automatisk opdateres?")]), _vm._v(" "), _c('ul', _vm._l((_vm.checkedItemsToUpdate), function(checkedItem) {
    return _c('li', {
      key: checkedItem.id
    }, [_c('b', [_vm._v(_vm._s(checkedItem.name) + ":")]), _vm._v(" " + _vm._s(_vm.formatEmploymentRateText(checkedItem, true)) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('template', {
    slot: "confirm_buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isModalAutoCalculateOpen = false
      }
    }
  }, [_vm._v("\n        Ikke opdatér\n      ")]), _vm._v(" "), _c('button', {
    ref: "submit_bttn",
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.updateActivePoolsFromEmploymentRate
    }
  }, [_vm._v("\n        Opdatér puljer\n      ")])])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4d65834!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursNorm.vue
// module id = 1741
// module chunks = 1